import React, { useState, useEffect } from "react";
import ImageComponent from "@project-stories/elements/Image/Image";
import arcBridge from 'frontend/js/arcBridge';
import AccountProfile from "./AccountProfile";
import AccountProfileHistory from "./AccountProfileHistory";

export const AccountRewards = ({ settings }) => {
  const { section } = settings;

  const [loading, setLoading] = useState(true);
  const [customerRewardsStatus, setCustomerRewardsStatus] = useState(null);
  const [showExpired, setShowExpired] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rewardsPerPage] = useState(10);

  useEffect(() => {
    async function getCustomerRewardsProfile() {
      try {
        const rewardsProfile = await arcBridge.getCustomerRewards();
        // console.log("rewardsProfile", rewardsProfile);
        if (rewardsProfile?.results) {
          const { tier, maintain_tier_value, next_tier_value, current_tier_anniversary } = rewardsProfile.results;

          const nextTier = tier === "Silver" ? "Gold" : tier === "Gold" ? "Platinum" : "Platinum";
  
          setCustomerRewardsStatus({
            tier: tier,
            maintainTierValue: maintain_tier_value,
            nextTierValue: next_tier_value,
            nextTier: nextTier,
            date: new Date(current_tier_anniversary).toLocaleDateString("en-AU", { year: 'numeric', month: 'long', day: 'numeric' })
          });
        }
      } catch (error) {
        console.error("Failed to fetch rewards profile:", error);
      } finally {
        setLoading(false);
      }
    }
    getCustomerRewardsProfile();
  }, []);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const diamondIconSilver = (
    <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5126 28.3014L37.9411 6.64811L33.0865 0.664786L33.1335 0.61742L32.8508 0.332559L32.5681 0H5.37302L0 6.64778L18.4285 28.3011L18.947 28.9185L19.5126 28.3014ZM12.8199 6.26823L18.994 1.51969L25.1682 6.26823H12.8199ZM19.6069 0.854897H31.6727L26.394 6.12578L19.6069 0.854897ZM11.6416 6.07812L6.74003 0.854558H18.4287L11.6416 6.07812ZM10.6047 6.26825H1.4611L5.65583 1.04469L10.6047 6.26825ZM25.8282 7.12282L18.9942 27.1616L12.1602 7.12282H25.8282ZM26.7238 7.12282H36.433L20.2668 26.0695L26.7238 7.12282ZM36.5272 6.26825H27.4779L32.4738 1.2822L36.5272 6.26825ZM1.55545 7.12282H11.2646L17.7216 26.0695L1.55545 7.12282Z" fill="#A2A9AD"/>
    </svg>
  );
  const diamondIconGold = (
    <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5126 28.3014L37.9411 6.64811L33.0865 0.664786L33.1335 0.61742L32.8508 0.332559L32.5681 0H5.37302L0 6.64778L18.4285 28.3011L18.947 28.9185L19.5126 28.3014ZM12.8199 6.26823L18.994 1.51969L25.1682 6.26823H12.8199ZM19.6069 0.854897H31.6727L26.394 6.12578L19.6069 0.854897ZM11.6416 6.07812L6.74003 0.854558H18.4287L11.6416 6.07812ZM10.6047 6.26825H1.4611L5.65583 1.04469L10.6047 6.26825ZM25.8282 7.12282L18.9942 27.1616L12.1602 7.12282H25.8282ZM26.7238 7.12282H36.433L20.2668 26.0695L26.7238 7.12282ZM36.5272 6.26825H27.4779L32.4738 1.2822L36.5272 6.26825ZM1.55545 7.12282H11.2646L17.7216 26.0695L1.55545 7.12282Z" fill="#CDA176"/>
    </svg>
  );
  const diamondIconPlatinum = (
    <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5126 28.3014L37.9411 6.64811L33.0865 0.664786L33.1335 0.61742L32.8508 0.332559L32.5681 0H5.37302L0 6.64778L18.4285 28.3011L18.947 28.9185L19.5126 28.3014ZM12.8199 6.26823L18.994 1.51969L25.1682 6.26823H12.8199ZM19.6069 0.854897H31.6727L26.394 6.12578L19.6069 0.854897ZM11.6416 6.07812L6.74003 0.854558H18.4287L11.6416 6.07812ZM10.6047 6.26825H1.4611L5.65583 1.04469L10.6047 6.26825ZM25.8282 7.12282L18.9942 27.1616L12.1602 7.12282H25.8282ZM26.7238 7.12282H36.433L20.2668 26.0695L26.7238 7.12282ZM36.5272 6.26825H27.4779L32.4738 1.2822L36.5272 6.26825ZM1.55545 7.12282H11.2646L17.7216 26.0695L1.55545 7.12282Z" fill="#020202"/>
    </svg>
  );

  return (
    <>
      <AccountProfile />
      <div className="flex flex-col items-center mt-8">
        <div className="flex items-end justify-around w-full">
          <div className="flex flex-col items-center gap-y-[14px]">
            {customerRewardsStatus?.tier === "Silver" && (diamondIconSilver)}
            <h5 className={customerRewardsStatus?.tier === "Silver" ? "text-[#A2A9AD]" : "text-[#54565A]"}>Silver</h5>
          </div>
          
          <div className="flex flex-col items-center gap-y-[14px]">
            {customerRewardsStatus?.tier === "Gold" && (diamondIconGold)}
            <h5 className={customerRewardsStatus?.tier === "Gold" ? "text-[#CDA176]" : "text-[#99A8B2]"}>Gold</h5>
          </div>
          
          <div className="flex flex-col items-center gap-y-[14px]">
            {customerRewardsStatus?.tier === "Platinum" && (diamondIconPlatinum)}
            <h5 className={customerRewardsStatus?.tier === "Platinum" ? "text-[#54565A]" : "text-[#99A8B2]"}>Platinum</h5>
          </div>
        </div>

        <div className="relative w-full mt-4">
          <div className="absolute top-0 left-0 h-[2px] bg-[#ECEEEF] w-full"></div>
          <div
            className="absolute top-0 left-0 h-[2px]"
            style={{
              background:
                customerRewardsStatus?.tier === "Silver" || (customerRewardsStatus?.tier === "Gold" && customerRewardsStatus?.tier === "Platinum")
                  ? "linear-gradient(270deg, rgba(84, 86, 90, 1) 0%, rgba(84, 86, 90, 1) 50%, rgba(84, 86, 90, 0) 100%)"
                  : customerRewardsStatus?.tier === "Gold"
                  ? "linear-gradient(270deg, rgba(84, 86, 90, 1) 0%, rgba(84, 86, 90, 1) 50%, rgba(84, 86, 90, 0) 100%)"
                  : customerRewardsStatus?.tier === "Platinum"
                  ? "linear-gradient(270deg, rgba(84, 86, 90, 0) 0%, rgba(84, 86, 90, 1) 50%, rgba(84, 86, 90, 0) 100%)"
                  : "#ECEEEF",
              width:
                customerRewardsStatus?.tier === "Silver"
                  ? "16%"
                  : customerRewardsStatus?.tier === "Gold"
                  ? "48%"
                  : customerRewardsStatus?.tier === "Platinum"
                  ? "100%"
                  : "0%",
            }}
          ></div>

          <div className="absolute left-0 flex justify-between w-full mt-1 -top-[6px]">
            <div
              className={`w-[6px] h-[6px] rounded-full absolute ${
                customerRewardsStatus?.tier === "Silver" || customerRewardsStatus?.tier === "Gold" || customerRewardsStatus?.tier === "Platinum"
                  ? "bg-[#54565A]"
                  : "bg-[#ECEEEF]"
              }`}
              style={{
                left: "16%",
              }}
            ></div>

            <div
              className={`w-[6px] h-[6px] rounded-full absolute ${
                customerRewardsStatus?.tier === "Gold" || customerRewardsStatus?.tier === "Platinum"
                  ? "bg-[#54565A]"
                  : "bg-[#ECEEEF]"
              }`}
              style={{
                left: "47.3%",
              }}
            ></div>

            <div
              className={`w-[6px] h-[6px] rounded-full absolute ${
                customerRewardsStatus?.tier === "Platinum" ? "bg-[#54565A]" : "bg-[#ECEEEF]"
              }`}
              style={{
                left: "81%",
              }}
            ></div>
          </div>
        </div>

        {!loading && (
          <div className="my-[21px] text-center text-[#D12727] b3">
            {customerRewardsStatus?.tier !== "Platinum" && (
              <div>
                Spend <span className="font-medium text-base/[22px]">${customerRewardsStatus?.nextTierValue}</span> or more by 
                <span className="font-medium text-base/[22px]"> {customerRewardsStatus?.date}</span> to reach 
                <span className="font-medium text-base/[22px]"> {customerRewardsStatus?.nextTier}</span>
              </div>
            )}
            {customerRewardsStatus?.tier !== "Silver" && (
              <div>
                Spend <span className="font-medium text-base/[22px]">${customerRewardsStatus?.maintainTierValue}</span> more by 
                <span className="font-medium text-base/[22px]"> {customerRewardsStatus?.date}</span> to maintain 
                <span className="font-medium text-base/[22px]"> {customerRewardsStatus?.tier}</span>
              </div>
            )}
          </div>
        )}
        
      </div>

      <div className="grid gap-6 my-6 md:grid-cols-3">
        <div>
          <ImageComponent
            classes="w-full h-auto"
            imageUrl={section.tier_service_silver_image}
          />
        </div>
        <div>
          <ImageComponent
            classes="w-full h-auto"
            imageUrl={section.tier_service_gold_image}
          />
        </div>
        <div>
          <ImageComponent
            classes="w-full h-auto"
            imageUrl={section.tier_service_platinum_image}
          />
        </div>
      </div>

      <AccountProfileHistory
        showExpired={showExpired}
        currentPage={currentPage}
        rewardsPerPage={rewardsPerPage}
        onPageChange={paginate}
        onToggleExpired={() => setShowExpired(!showExpired)}
      />
    </>
  );
};

export default AccountRewards;